"use client";

import * as React from "react";
import {
  ImageContext,
  type ImageProviderComponentProps,
} from "./image-provider";

export function useImage():
  | React.ComponentType<ImageProviderComponentProps>
  | undefined {
  return React.useContext(ImageContext).Override;
}

export function sanitizeAlt(
  alt: string,
  decorative: boolean,
  decorativeLabel?: string
): string {
  if (decorative) {
    return decorativeLabel || "";
  }
  return alt;
}
